import React, { useState, useEffect, useRef } from "react";
import "./Carousal.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NoImage from "../../../assets/images/No_Image.jpg";

const getSlidesPerView = () => {
  const width = window.innerWidth;
  if (width <= 480) return 1;
  if (width <= 768) return 2;
  if (width <= 1024) return 3;
  if (width <= 1240) return 3;
  if (width <= 1440) return 4;
  if (width <= 1540) return 4;
  if (width <= 1640) return 5;
  if (width <= 1940) return 5;
  if (width > 1940) return 6;
};

const NO_IMAGE_BLOB_URL = "https://jewelcloudstagingdiag.blob.core.windows.net/gemfind2staging/CollectionImages/No Image.png";

const getImageSrc = (item) => {
  if (item?.imageAdv && item.imageAdv !== "" && item.imageAdv !== NO_IMAGE_BLOB_URL) {
    return item.imageAdv;
  }
  if (item?.image1) {
    return item.image1;
  }
  return NoImage;
};

const handleImageError = (e, item) => {
  if (e.target.src === item?.imageAdv && item?.image1) {
    e.target.src = item.image1;
  } else {
    e.target.src = NoImage;
  }
};

const CustomCarousel = ({ images, handleRequestAcces }) => {
  const [slidesPerView, setSlidesPerView] = useState(getSlidesPerView());
  const [currentIndex, setCurrentIndex] = useState(0);
  const trackRef = useRef(null);
  const { t } = useTranslation();
  const autoRotateInterval = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const newSlides = getSlidesPerView();
      setSlidesPerView(newSlides);
      setCurrentIndex(0); // Reset to prevent mismatch
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto-rotation effect
  useEffect(() => {
    // Clear any existing interval
    if (autoRotateInterval.current) {
      clearInterval(autoRotateInterval.current);
    }

    // Set up new interval for auto-rotation (every 5 seconds)
    autoRotateInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);

    // Cleanup interval on component unmount
    return () => {
      if (autoRotateInterval.current) {
        clearInterval(autoRotateInterval.current);
      }
    };
  }, [images.length]);

  const nextSlide = () => {
    // Reset the auto-rotation timer when manually navigating
    if (autoRotateInterval.current) {
      clearInterval(autoRotateInterval.current);
      autoRotateInterval.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
      }, 5000);
    }
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    // Reset the auto-rotation timer when manually navigating
    if (autoRotateInterval.current) {
      clearInterval(autoRotateInterval.current);
      autoRotateInterval.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
      }, 5000);
    }
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const getVisibleImages = () => {
    const visible = [];
    for (let i = 0; i < slidesPerView; i++) {
      const index = (currentIndex + i) % images.length;
      visible.push(images[index]);
    }
    return visible;
  };

  const visibleImages = getVisibleImages();

  return (
    <div className="carousel-wrapper">
      <button className="carousel-arrow left" onClick={prevSlide}>
        ‹
      </button>
      <div className="carousel-window">
        <div className="slider-track" ref={trackRef}>
          {visibleImages.map((item, idx) => (
            <div
              className="carousel-slide"
              style={{ width: `${100 / slidesPerView}%` }}
              key={idx}
            >
              <div className="item">
                <div
                  className="vendor-slider__item"
                  style={{ position: "relative", width: "100%" }}
                >
                  <div
                    className="bgimage"
                    style={{ position: "relative", width: "100%" }}
                  >
                    <img
                      src={getImageSrc(item)}
                      onError={(e) => handleImageError(e, item)}
                      alt="bgimage"
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "contain",
                        display: "block"
                      }}
                    />
                    <div
                      className="vendor-hover-overlay"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <div className="vendor-top-half"></div>
                      <div
                        className="vendor-bottom-half_catalog"
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          width: "100%",
                        }}
                      >
                        <div
                          className="vendor-dealer-info"
                          title={item?.dealerCompany}
                        >
                          {item?.dealerCompany?.length > 30
                            ? item?.dealerCompany.slice(0, 30) + "..."
                            : item?.dealerCompany}
                        </div>
                        <div className="vendor-button-container">
                          <Link
                            to={"/vendorProfile"}
                            state={{
                              key: "Profile",
                              id: item?.dealerID,
                            }}
                          >
                            <button className="primary-btn">
                              {t("View Profile")}
                            </button>
                          </Link>

                          <button
                            className="primary-btn"
                            onClick={
                              item?.action == "Send Invitation" ||
                              item?.action == "Request Access"
                                ? () => handleRequestAcces(item)
                                : undefined
                            }
                          >
                            {" "}
                            {item?.action == "Send Invitation" ||
                            item?.action == "Request Access"
                              ? t("Request Access")
                              : t("Connected")}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <button className="carousel-arrow right" onClick={nextSlide}>
        ›
      </button>
    </div>
  );
};

export default CustomCarousel;
